<template lang="pug">
#tabela-listagem-territorio-contrato
    .tabela-listagem-territorio-contrato__tabela
        .tabela-listagem-territorio-contrato__tabela__header
            h1 Listagem de territórios

        el-table(:data='itens'
                v-loading='carregandoDadosContratos'
                stripe)
            el-table-column(prop='territorioNome', label='Território')
            el-table-column(prop='pessoaNome', label='Pessoa')
            el-table-column(prop='cpfCnpj', label='Documento')
            el-table-column(prop='volumeInformado', label='Volume (t)')
            template(slot='empty')
                el-empty(
                    description='Sem dados'
                )

    .tabela-listagem-territorio-contrato__paginacao
        span.territorio
            | {{ paginacao.total }} territórios

        span.tonelada
            | {{ volumeTotalTon }} toneladas

        el-pagination(
            small,
            background,
            layout='prev, pager, next',
            :page-size='paginacao.itensPorPagina',
            :current-page.sync='paginacao.pagina',
            :total='paginacao.total',
            @current-change='buscarDadosContratos(paginacao.pagina - 1)'
        )
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
export default {
    name: 'TabelaListagemTerritorioContrato',
    data() {
        return {
            itens: [],
            carregandoDadosContratos: false,
            volumeTotalTon: 0,
            filtrarPorTerritorioComRestricao: false,
            paginacao: {
                itensPorPagina: 10,
                pagina: 0,
                total: 0,
                totalPaginas: 0
            },
            numeroContrato: this.$route.params.numeroContrato
        };
    },
    mounted() {
        this.buscarDadosContratos(0);
    },

    methods: {
        async buscarDadosContratos(pagina) {
            this.carregandoDadosContratos = true;
            try {
                this.paginacao.pagina = pagina;
                const { data } =
                    await ContratoOriginacaoService.buscarDadosContratosOriginacao({
                        numeroContrato: this.numeroContrato,
                        page: this.paginacao.pagina,
                        size: this.paginacao.itensPorPagina,
                        territoriosComRestricoes: this.filtrarPorTerritorioComRestricao
                    });
                this.itens = data.itens;
                this.volumeTotalTon = data.volumeTotalTon;
                this.paginacao = { ...data.paginacao };
                this.paginacao.pagina += 1;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de buscar dados dos contratos.'
                });
            }
            this.carregandoDadosContratos = false;
        }
    }
};
</script>
<style lang="scss">
#tabela-listagem-territorio-contrato {
    box-shadow: 0 0 10px rgb(0 0 0 / 0%);

    h1,
    .el-checkbox {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }
    .tabela-listagem-territorio-contrato__tabela {
        el-table-column {
            justify-content: space-between;
        }

        .el-table {
            border-top-right-radius: 11px;
            border-top-left-radius: 11px;
            min-height: 240px;
            thead.has-gutter {
                height: 67px;
                th.el-table__cell {
                    background-color: #FBFBFB;
                }
            }
        }

        .tabela-listagem-territorio-contrato__tabela__header {
            flex-direction: row;
            display: flex;
            justify-content: space-between;
            gap: 15px;
        }
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-listagem-territorio-contrato__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;
        gap: 10px;

        .territorio {
            color: var(--primary);
            font-weight: 600;
        }

        .tonelada {
            color: var(--primary);
            font-weight: 600;
            flex-grow: 2;
        }
    }
    .tabela-listagem-icone {
        i {
            font-size: 27px;
        }
    }

    .tonelada {
        flex-grow: 2;
    }
}
</style>
